import {UIGameManager} from 'code/client/shared/scripts/ui_game/UIGameManager'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameFeedView} from '../../../../shared/scripts/ui_game/ui_game_feed/UIGameFeedView'

export class UIWGameFeedView extends UIGameFeedView {
    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)

        this.gameLog.mainBlock.hidden = true
        this.gameChat.mainBlock.hidden = true
    }

    protected setSize(w: number, h: number) {
        let zoom = 1
        if(this.isMobile) zoom = 0.5
        if(this.isTablet) zoom = 1
        if(UIUtilsEjsVariables.isUserOnDiscord) zoom = 0.75

        const MARGIN = this.uiGameManager.canvasController.margin
        const divHeight = (h / zoom) - (MARGIN * 2.75 / zoom) - this.INPUT_ELEMENT_HEIGHT - this.GAME_BLOCK_PADDING * 2
        const divHeightNoChat = (h / zoom) - (MARGIN * 2 / zoom) - this.GAME_BLOCK_PADDING
        const divWidth = (w / zoom) - (MARGIN * 2 / zoom) - this.GAME_BLOCK_PADDING

        this.gameChat.scale(zoom)
        this.gameChat.setMargin(MARGIN / zoom)
        this.gameChat.setHeight(divHeight * 0.4)
        this.gameChat.setWidth(divWidth)
        this.gameChat.setFormWidth(divWidth)

        this.gameLog.scale(zoom)
        this.gameLog.setHeight(this.isChatEnabled == false ? divHeightNoChat : divHeight * 0.6)
        this.gameLog.setWidth(divWidth)

        const replayViewMaxWidth = 400
        this.replayView?.setWidth(Math.min(divWidth, replayViewMaxWidth))
    }

    protected setPosition(canvasX: number, canvasY: number) {
        const MARGIN = this.uiGameManager.canvasController.margin
        let zoom = 1
        if(this.isMobile) zoom = 2
        if(this.isTablet) zoom = 1
        if(UIUtilsEjsVariables.isUserOnDiscord) zoom = 1.33

        this.gameChat.setPositionRight(canvasX + MARGIN)
        this.gameChat.setPositionTop(((this.gameLog.mainBlock.clientHeight + canvasY + MARGIN) / zoom))

        this.gameLog.setPositionRight(canvasX + MARGIN)
        this.gameLog.setPositionTop(canvasY + MARGIN)

        if(this.replayView) {
            const logWidth = this.gameLog.mainBlock.offsetWidth / zoom
            this.replayView.setPositionRight(canvasX + MARGIN + logWidth + MARGIN)
            this.replayView.setPositionTop(canvasY + MARGIN)
        }
    }
}
